<footer id="footer" class="footer">
  <div class="container-fluid">
    <div class="m-2">
      <div *ngIf="isFun && this.displayWotd" class="m-2">
        <b class="mt-3">Word of the day is {{wotd.word | uppercase}} </b>
        <button class="definition-btn btn btn-sm btn-light" (click)="expanded = !expanded">
          {{(expanded)? "Hide" : "Show"}} definitions</button>
        <ul *ngIf="expanded" class="list-unstyled">
          <li *ngFor="let def of wotd.definitions">{{def.text}}</li>
        </ul>
      </div>
      <p> <a class="badge badge-light" rel="noopener noreferrer" target="_blank"
          href="mailto:michaelpaulhoe+willandvillagehall@gmail.com">
          Website built by Michael Hoe
        </a></p>
    </div>
  </div>
</footer>
